import './contact.css';
import '../view.css';
import email from './contactimage/email.png';
import github from './contactimage/github.png';
import linkedin from './contactimage/linkedin.png';

export const Contact = () => (
    <div className='view' id='contactview'>

        <div className='contactcontainer'>

            <div className='contactbox'>
                <span></span>
                <div className='contactcontent'>
                    <h2>LinkedIn</h2>
                    <img src={linkedin} alt="linkedin" />
                    <a href='https://www.linkedin.com/in/igorlt96/'> Click Here</a>
                </div>
            </div>

            <div className='contactbox'>
                <span></span>
                <div className='contactcontent'>
                    <h2>E-mail</h2>
                    <img src={email} alt="email" />
                    <a href='mailto:igorlt96@hotmail.com'> Click Here</a>
                </div>
            </div>

            <div className='contactbox'>
                <span></span>
                <div className='contactcontent'>
                    <h2>GitHub</h2>
                    <img src={github} alt="github" />
                    <a href='https://github.com/GitScrider'> Click Here</a>
                </div>
            </div>
        </div>

    </div>
);
